import { Button } from "../../primitives";
import { useState } from "react";
import Modal from "../../portals/Modal";
import { catchErrorParse } from "../../../ErrorUtility";
import SubscriptionInfo from "../../popup/SubscriptionInfo";
import CancelSubscription from "../../popup/CancelSubscription";
import { useTranslation } from "../../../hooks/useTranslation";
import { useOutletContext } from "react-router-dom";
import { useDatabase } from "../../../contexts/DatabaseContext";

export default function UnregisteredSubscription({ subscription, loading, post, url, totalCost }) {
    const [states, setStates] = useState({ isOpen: false, option: 0 });
    const t = useTranslation();
    const { getInvoiceData, getBalance } = useOutletContext();
    const { createSubscriptionActionEvent } = useDatabase();

    async function handleCancelSubscription() {
        const [result, error, errorCode, errorMessage] = await catchErrorParse(post, `${url}/webapp/subscriptions/dec`, {
            subscriptionId: subscription.id,
        });
        if (error) {
            window.dispatchEvent(new CustomEvent('masterError', {
                detail: {
                    code: errorCode,
                    message: errorMessage ? errorMessage : error.message,
                    action: "cancel_unregistered",
                    diabolical: true,
                }
            }));
        } else {
            getInvoiceData();
            getBalance();
            createSubscriptionActionEvent("cancel_unregistered", result.latest_invoice.total);
        }
        setStates({ isOpen: false, option: 0 });
    }

    return (
        <>
            <div className='workspace-subscription-row'>
                <Button className='workspace-subscription-button unregistered-layout' onClick={() => setStates({ isOpen: true, option: 0 })}>{totalCost}</Button>
                <Button className='workspace-subscription-button cancel unregistered-layout' disabled={loading} onClick={() => setStates({ isOpen: true, option: 1 })}>{t('Cancel Subscription')}</Button>
            </div>
            <Modal open={states.isOpen} onClickOutside={() => setStates({ isOpen: false, option: 0 })} lock={loading}>
                {
                    states.option === 0 ? 
                        <SubscriptionInfo subscription={subscription} onClose={() => setStates({ isOpen: false, option: 0 })} totalCost={totalCost}/> : 
                        <CancelSubscription onConfirm={handleCancelSubscription} onCancel={() => setStates({ isOpen: false, option: 0 })}/>
                }
            </Modal>
        </>
    )
}
